<template>
  <div
    id="NotValidNoticePopup"
    class="modal fade confirm NotValidNoticePopup"
    :class="{ 'is-open': open }"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click.stop="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">重要提醒</h3>
        </div>
        <div class="modal-body px_0 py_0 text-sm">
          <!-- -------------------主要區塊start ----------------------->
          <section class="segment NotValidNoticePopup__section pb_5">
            <h4 class="text-green">客戶無法承保以下商品:</h4>
            <div class="notice mt_5">
              系統將自動剔除不匯入(主約與其底下附加的附約將一同剔除)
            </div>
            <div class="notvalidList mt_10">
              <div
                v-for="(item, index) in notValidList"
                :key="item.prod.prod_name"
              >
                <p
                  v-if="
                    index == 0 || item.index != notValidList[index - 1].index
                  "
                >
                  建議{{ item.index }}:
                </p>
                <div class="notvalidList__item mb_4">
                  <div class="notvalidList__item--name mf-textWrap">
                    {{ `${item.prod.prod_name}`
                    }}<span class="mf-textNoWrap">{{
                      `(${item.prod.prod_id})`
                    }}</span>
                  </div>
                  <div class="notvalidList__item--reason mf-textWrap">
                    {{ item.prod.error }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 確定按鈕 -->
            <div class="action text-right mt_10">
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5 ml_10"
                @click.stop="$emit('close')"
              >
                確定
              </button>
            </div>
          </section>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import ProductSelect from "@/desktop/views/mf/plugin/vue-select/src/index.js";
export default {
  components: { ProductSelect },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    notValidList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.NotValidNoticePopup {
  .segment {
    padding: 10px 40px 10px;
    margin-top: 0;
    margin-bottom: 10px;
    border-radius: 0;
  }
  .notice {
    font-size: 20px;
  }
  .notvalidList {
    border: solid 1px #53c480;
    background-color: #fff;
    padding: 16px 20px;
    &__item {
      width: 100%;
      display: flex;
      align-items: center;
      border-radius: 4px;
      background-color: #f5f5f5;
      padding: 2px 20px;
      &--name {
        width: 76%;
        color: #323a45;
      }
      &--reason {
        width: 24%;
        font-size: 14px;
        color: #de4054;
      }
    }
  }
}
</style>
